/**
 * Channel Types
 *
 * 채널 타입을 정의하는 열거형
 */
export enum Channel {
    IB = 'IB', //인터넷뱅킹
    MB = 'MB', //모바일뱅킹
    MW = 'MW', //모바일웹
}
